import slugify from 'react-slugify';

export const toSlugify = (str: string) => {
  if (str) {
    str = str.split('.').join('-');
    return slugify(str);
  }
  return str;
};
